import { render } from "./PaymentError.vue?vue&type=template&id=2d9f984f"
import script from "./PaymentError.vue?vue&type=script&lang=js"
export * from "./PaymentError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__